import script from "./MailContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailContent.vue?vue&type=script&setup=true&lang=ts"

import "./MailContent.vue?vue&type=style&index=0&id=52dd15db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52dd15db"]])

export default __exports__